var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete_red",
    "data-name": "Delete red",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.2,
    height: 29.2,
    viewBox: "0 0 29.2 29.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M23.9,7.84h7.3v2.92H28.28V29.74a1.46,1.46,0,0,1-1.46,1.46H6.38a1.46,1.46,0,0,1-1.46-1.46V10.76H2V7.84H9.3V3.46A1.46,1.46,0,0,1,10.76,2H22.44A1.46,1.46,0,0,1,23.9,3.46Zm1.46,2.92H7.84V28.28H25.36ZM12.22,15.14h2.92V23.9H12.22Zm5.84,0h2.92V23.9H18.06ZM12.22,4.92V7.84h8.76V4.92Z",
    transform: "translate(-2 -2)",
    fill: "#ee5f5f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.669c6df31d79fedabc9e88071acee9eb.svg";
export { ForwardRef as ReactComponent };